import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { AvadresseService } from './api/avadresse.service';
import { AvbemerkungService } from './api/avbemerkung.service';
import { AvbodenbedeckungService } from './api/avbodenbedeckung.service';
import { AvflaecheService } from './api/avflaeche.service';
import { AvflaechenanteilService } from './api/avflaechenanteil.service';
import { AvgbplanService } from './api/avgbplan.service';
import { AvgebaeudeService } from './api/avgebaeude.service';
import { AvgeometerbueroService } from './api/avgeometerbuero.service';
import { AvgeometergeschaeftService } from './api/avgeometergeschaeft.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ApiModule> {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
